import { User, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";

interface WelcomeBackBannerProps {
  user: {
    email?: string;
  };
}

const WelcomeBackBanner = ({ user }: WelcomeBackBannerProps) => {
  const handleOpenApp = () => {
    window.open('https://app.zimkonnect.com', '_blank');
  };

  return (
    <div className="bg-gradient-to-r from-blue-50 to-orange-50 border-b border-blue-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex items-center justify-between flex-wrap gap-3">
          <div className="flex items-center space-x-3">
            <div className="flex items-center space-x-2 text-blue-700">
              <User size={18} />
              <span className="text-sm font-medium">Welcome back!</span>
            </div>
            <span className="text-sm text-gray-600 hidden sm:inline">
              {user.email}
            </span>
          </div>
          
          <div className="flex items-center space-x-3">
            <span className="text-sm text-gray-600 hidden sm:inline">
              Ready to continue tracking your projects?
            </span>
            <Button
              onClick={handleOpenApp}
              size="sm"
              className="bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white"
            >
              <span>Open App</span>
              <ArrowRight size={16} className="ml-1" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeBackBanner;